import { render, staticRenderFns } from "./transfer_order_apply.vue?vue&type=template&id=3f88cb85"
import script from "./transfer_order_apply.vue?vue&type=script&lang=js"
export * from "./transfer_order_apply.vue?vue&type=script&lang=js"
import style0 from "./transfer_order_apply.vue?vue&type=style&index=0&id=3f88cb85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports